import React from 'react';
import { AgentRoster } from './AgentRoster';
import { FloorMapCanvas } from './FloorMapCanvas';
import { ActionPanel } from './ActionPanel';
import { EventFeed } from './EventFeed';
import { ErrorBoundary } from '@/components/layout/ErrorBoundary';

export const LiveView: React.FC = () => {
  return (
    <div className="flex flex-col md:flex-row flex-1 overflow-y-auto md:overflow-hidden">
      {/* ── Roster (gauche desktop / haut mobile) ─────────────── */}
      <AgentRoster />

      {/* ── Centre : plan + flux ──────────────────────────────── */}
      <div className="flex flex-col flex-1 overflow-hidden min-h-[50vh] md:min-h-0 order-first md:order-none">
        <ErrorBoundary>
          <FloorMapCanvas />
        </ErrorBoundary>
        <EventFeed />
      </div>

      {/* ── Panneau droit (bas mobile) ────────────────────────── */}
      <ActionPanel />
    </div>
  );
};
